/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/no-unknown-property */
import React, { useContext } from 'react'

import { defaultToEmptyString, twoDigits } from '../../../assets/ts/formatting/formatting'
import { UserContext } from '../../../store/user-context-provider'

/* KPIs effected 
Inquiries Page: "ALL", "Unassigned" "Active", "Assigned to me" "Assigned to Others" "Returned From Mpf" & "Elevated To Mpf"

*/
interface Props {
  filter: {
    tabTable?: string;
  };
  kpi: any;
  setKpiName: (name: string) => void;
  updateKpiFilter: (e: any, t?: any) => void;
}
const LargeKPI = ({filter, kpi, setKpiName, updateKpiFilter }: Props) => {
  const userContext = useContext(UserContext)
  const currentUser = userContext?.me?.rid ?? ''

  const handleAll = (sectionCode, updateKpiFilter: (e) => void) => {
    updateKpiFilter({
      activeFilter: filter?.tabTable === 'ACTIVE' ? true : null,
      assignedToMe: null,
      assignedToOther: null,
      currentSection:undefined,
      customerActionRequiredFilter: null,
      elevatedToMPF: null,
      isCPOwnerOrLeadership:null,
      isResponsePending: null,   
      isResponseRequired: null,
      needToWorkFilter:null,
      pendingActionOutsideFilter: null,
      returnedFromMPF:null,
      sectionCodeKPIFilter: sectionCode,
      statusCodeFilter: '',
      unassignedFilter: filter?.tabTable === 'UNASSIGNED' ? true : null,
    })
  }
  const handleUnassigned = (sectionCode, updateKpiFilter: (e) => void) => {
    updateKpiFilter({
      activeFilter: null,
      assignedToMe: null,
      assignedToOther: null,
      currentSection:undefined,
      customerActionRequiredFilter: null,
      elevatedToMPF: null,
      isCPOwnerOrLeadership:null,
      isResponsePending: null,
      isResponseRequired: null,
      needToWorkFilter:null,
      pendingActionOutsideFilter: null,
      returnedFromMPF:null,
      sectionCodeKPIFilter: sectionCode,
      statusCodeFilter: '',
      unassignedFilter: true,
    })
  }
  const handleActive = (sectionCode, updateKpiFilter: (e) => void) => {
    updateKpiFilter({
      activeFilter: true,
      assignedToMe: null,
      assignedToOther: null,
      currentSection:undefined,
      customerActionRequiredFilter: null,
      elevatedToMPF: null,
      isCPOwnerOrLeadership:null,
      isResponsePending: undefined,   
      isResponseRequired: undefined,
      needToWorkFilter:null,
      pendingActionOutsideFilter: null,
      returnedFromMPF: null,
      sectionCodeKPIFilter: sectionCode,
      statusCodeFilter: '',
      unassignedFilter: null,
    })
  }
  const handleAssignedToMe = (sectionCode, updateKpiFilter: (e) => void, currentUser) => {
    updateKpiFilter({
      activeFilter: null,
      assignedToMe: currentUser,
      assignedToOther: null,
      currentSection:undefined,
      customerActionRequiredFilter: null,
      elevatedToMPF: null,
      isCPOwnerOrLeadership:null,   
      isResponsePending: undefined,
      isResponseRequired: undefined,
      needToWorkFilter:null,
      pendingActionOutsideFilter: null,
      returnedFromMPF: null,
      sectionCodeKPIFilter: sectionCode,
      statusCodeFilter: undefined,
      unassignedFilter: null,
    })
  }
  const handleAssignedToOthers = (sectionCode, updateKpiFilter: (e) => void, currentUser) => {
    updateKpiFilter({
      activeFilter: null,
      assignedToMe: undefined,
      assignedToOther: currentUser,
      currentSection:undefined,
      customerActionRequiredFilter: undefined,
      elevatedToMPF: null,
      isCPOwnerOrLeadership:null,
      isResponsePending: undefined,
      isResponseRequired: undefined,
      needToWorkFilter:null,
      pendingActionOutsideFilter: null,
      returnedFromMPF: null,
      sectionCodeKPIFilter: sectionCode,
      statusCodeFilter: undefined,
      unassignedFilter: null,
    })
  }
  const handleReturnedFromMpf = (sectionCode, updateKpiFilter: (e) => void) => {
    updateKpiFilter({
      activeFilter: null,
      assignedToMe: null,
      assignedToOther: null,
      currentSection:null,
      customerActionRequiredFilter: null,
      elevatedToMPF: null,   
      isCPOwnerOrLeadership:null,
      isResponsePending: false,
      isResponseRequired: false,
      needToWorkFilter:null,
      pendingActionOutsideFilter: null,
      returnedFromMPF: true,
      sectionCodeKPIFilter: -1,
      statusCodeFilter: '',
      unassignedFilter: null
    })
  }
  const handleElevatedToMpf = (sectionCode, updateKpiFilter: (e) => void) => {
    updateKpiFilter({
      activeFilter: null,
      assignedToMe: null,
      assignedToOther: null,
      currentSection:null,
      customerActionRequiredFilter: null,
      elevatedToMPF: true,
      isCPOwnerOrLeadership:null,
      isResponsePending: null,
      isResponseRequired: null,   
      needToWorkFilter:null,
      pendingActionOutsideFilter: null,
      returnedFromMPF: null,
      sectionCodeKPIFilter: -1,
      statusCodeFilter: '',
      unassignedFilter: null,
    })
  }

  const handleKPIUpdate = (kpi, updateKpiFilter: (e) => void, currentUser) => {
    const { sectionCode, title } = kpi
    if (!updateKpiFilter) return
    setKpiName(title)
    const KPIs = {
      active: handleActive,
      all: handleAll,
      'assigned to me': (sectionCode) =>
        handleAssignedToMe(sectionCode, updateKpiFilter, currentUser),
      'assigned to others': (sectionCode) =>
        handleAssignedToOthers(sectionCode, updateKpiFilter, currentUser),
      'elevated to mpf': handleElevatedToMpf,
      'returned from mpf': handleReturnedFromMpf,
      unassigned: handleUnassigned,
    }

    const handleKPI = KPIs[title.toLowerCase()]

    if (handleKPI) {
      handleKPI(sectionCode, updateKpiFilter)
    } else {
      console.warn(`No handler found for kpi title: ${title}`)
    }
  }

  return (
    <a
      aria-live='polite'
      className=' font-12 kpiborder border-radius align-items-center p-relative text-decoration-none d-flex flex-row w-100 p-0'
      onClick={() =>
        kpi.pageType
          ? updateKpiFilter(kpi.link, kpi.title)
          : handleKPIUpdate(kpi, updateKpiFilter, currentUser)
      }
      status-kpis={kpi.colorcode}
      style={{ pointerEvents: kpi.count === '00' ? 'none' : 'auto' }}
      tabIndex={0}
      title={defaultToEmptyString(kpi.title)}
    >
      <span className='border-right1 px-3 py-2 poppins-bold font-16'>{defaultToEmptyString(twoDigits(kpi.count))}</span>
      <span className='px-2 poppins-semibold font-12 text-nowrap text-uppercase'>{defaultToEmptyString(kpi.title)}</span>
    </a>
  )
}

export default LargeKPI
